import React, { Component } from 'react';
import { MagnifyingGlassIcon, PencilSquareIcon } from '@heroicons/react/20/solid';
import Breadcrumb from '../../Shared/BreadCumb';
import { Link } from "react-router-dom";
import { getAllPenalities, createUser, updateUser } from './services/penalities';
import ClipLoader from "react-spinners/ClipLoader";

import { ToastContainer, toast } from 'react-toastify';

class UsersPenalities extends Component {

    payed = 'inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20';
    pending = 'inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/20';

    BreadcrumbPages = [ 
        { name: 'Multas', href: '#', current: false },
        { name: 'Lista de multas', href: '#', current: true },
    ]

    constructor(props) {
        super(props)
        this.state = {
            items: [],
            loading:false,
            identification:'',
            numberPlate:'',
            dateEnd:'',
            dateStart:'',
            showCreateUserModal: false,
            createUserForm: {
                identification: '',
                firstName: '',
                middleName: '',
                firstLastName: '',
                middleLastName: '',
                gender: '',
                phone: [''],
                email: '',
                address: ''
            },
            createUserErrors: {},
            loadingCreateUser: false,
            showEditUserModal: false,
            editUserForm: {
                identification: '',
                email: '',
                phone:'',
                idUser:0,
            },
            loadingEditUser: false
        }
    }

    openCreateUserModal = () => {
        this.setState({ showCreateUserModal: true });
    }

    closeCreateUserModal = () => {
        this.setState({
            showCreateUserModal: false,
            createUserForm: {
                identification: '',
                firstName: '',
                middleName: '',
                firstLastName: '',
                middleLastName: '',
                gender: '',
                phone: [''],
                email: '',
                address: ''
            },
            createUserErrors: {}
        });
    }

    handleCreateUserChange = (e, idx = null) => {
        const { name, value } = e.target;
        if (name === 'phone' && idx !== null) {
            const phones = [...this.state.createUserForm.phone];
            phones[idx] = value;
            this.setState({ createUserForm: { ...this.state.createUserForm, phone: phones } });
        } else {
            this.setState({ createUserForm: { ...this.state.createUserForm, [name]: value } });
        }
    }

    addPhoneField = () => {
        this.setState({ createUserForm: { ...this.state.createUserForm, phone: [...this.state.createUserForm.phone, ''] } });
    }

    removePhoneField = (idx) => {
        const phones = [...this.state.createUserForm.phone];
        phones.splice(idx, 1);
        this.setState({ createUserForm: { ...this.state.createUserForm, phone: phones } });
    }

    validateCreateUserForm = () => {
        const errors = {};
        const { identification, firstName, firstLastName, gender, phone, email, address } = this.state.createUserForm;
        if (!identification) errors.identification = 'Requerido';
        if (!firstName) errors.firstName = 'Requerido';
        if (!firstLastName) errors.firstLastName = 'Requerido';
        if (!gender) errors.gender = 'Requerido';
        if (!phone || phone.some(p => !p)) errors.phone = 'Al menos un teléfono es requerido';
        if (!email) errors.email = 'Requerido';
        if (!address) errors.address = 'Requerido';
        return errors;
    }

    handleCreateUserSubmit = (e) => {
        this.setState({ loadingCreateUser: true });
        e.preventDefault();
        const errors = this.validateCreateUserForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ createUserErrors: errors });
            this.setState({ loadingCreateUser: false });
            return;
        }
        const { identification, firstName, firstLastName, gender, phone, email, address } = this.state.createUserForm;

        const body = {
            id:0,
            identification:identification,
            firstName:firstName,
            firstLastName:firstLastName,
            gender:gender,
            phone:phone,
            email:email,
            address:address,
            image:'',
        }
        createUser(body).then((result) => {
            if(result) {
                this.setState({identification: identification});
                this.closeCreateUserModal();
                this.getData();
                toast('Usuario creado correctamente');
            }
        }).catch((error) => {
            return toast(error);
        }).finally(() => {
            this.setState({ loadingCreateUser: false });
        });
    }

    openEditUserModal = (penalitie) => {
        this.setState({
            showEditUserModal: true,
            editUserForm: {
                identification: penalitie?.identification || '',
                email: penalitie?.email || '',
                idUser: this.getIdPerson(penalitie),
                phone: penalitie?.phone && Array.isArray(penalitie.phone) ? penalitie.phone[0] : '' || '',
            }
        });
    }

    getIdPerson(penalitie) {
        if(penalitie?.vehicle && penalitie?.vehicle.length > 0) {
            return penalitie.vehicle[0].idPerson;
        }
        if(penalitie?.headerFine && penalitie?.headerFine.length > 0) {
            return penalitie.headerFine[0].idPerson;
        }
        return 0;
    }

    closeEditUserModal = () => {
        this.setState({
            showEditUserModal: false,
            editUserForm: { identification: '', email: '', idUser:0 },
            loadingEditUser: false
        });
    }

    handleEditUserChange = (e) => {
        const { name, value } = e.target;
        if(name === 'phone' && isNaN(value)) {
            return;
        }
        this.setState({ editUserForm: { ...this.state.editUserForm, [name]: value } });
    }

    handleEditUserSubmit = (e) => {
        e.preventDefault();
        this.setState({ loadingEditUser: true });
        const body = {
            email:this.state.editUserForm.email, 
            idPerson:this.state.editUserForm.idUser,
            phone:[this.state.editUserForm.phone],
        };
        updateUser(body).then((result) => {
            if(result) {
                this.closeEditUserModal();
                this.getData();
            }
        }).catch((error) => {
            return toast(error);
        }).finally(() => {
            this.setState({ loadingEditUser: false });
        });
    }

    componentDidMount = () => {

    }

    getData = () => {
        const body = this.bodyData();
        if(body){
            this.setState({loading:true});
            getAllPenalities(body)
            .then((result) => {
                if(result && result.status === 200) {
                    this.setState({items:result.data.data, loading:false});
                } else {
                    toast(result);
                }
                this.setState({loading:false});
            }).catch((error) => {
                toast(error);
            })
        }
    }

    bodyData = () => {
        let body = {};
        if(this.state.identification !== '') {
            body.identification = this.state.identification;
        }
        if(this.state.numberPlate !== '') {
            body.numberPlate = this.state.numberPlate;
        }
        if(Object.keys(body).length === 0) {
            toast('Por favor rellene algunos campos para comenzar la busqueda');
            return null;
        }
        body.status = -1;
        return body;
    }


    setDateSearch = (type, value) => {
        if(type === 'start') {
            this.setState({dateStart:value.target.value});
        }else{
            this.setState({dateEnd:value.target.value});
        }
    }


    searchInput = () => {
        return (
            <div style={{display:'flex', flexDirection:'row'}}>
                <div>
                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                        Identificación
                    </label>
                    <div className="mt-2">
                        <input
                            value={this.state.identification}
                            onChange={(e) => {this.setState({identification:e.target.value})}}
                            type="text"
                            placeholder=""
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                    </div>
                </div>
                <div  style={{marginLeft:20}}>
                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                        Placa del Vehículo
                    </label>
                    <div className="mt-2">
                        <input
                            value={this.state.numberPlate}
                            onChange={(e) => {this.setState({numberPlate:e.target.value})}}
                            type="text"
                            placeholder=""
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                        />
                    </div>
                </div>
                <div  style={{marginLeft:20}}>
                    <button
                        onClick={() => this.getData()}
                        style={{marginTop:40}}
                        type="button"
                         className="rounded-md bg-white/10 px-3.5 py-1 text-sm font-semibold text-black shadow-sm hover:bg-white/20"
                        >
                            Buscar
                    </button>
                </div>
            </div>
        )
    }

    
    


    dateStartInput = () => {
        return(
            <div style={{width:'100%', paddingRight:5,}}>
                <div className="flex justify-between">
                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                    Fecha de inicio
                    </label>
                </div>
                <div className="mt-2">
                    <input
                    id="email"
                    name="email"
                    type="date"
                    placeholder="you@example.com"
                    aria-describedby="email-optional"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                    />
                </div>
            </div>
        )
    }

    dateEndInput = () => {
        return (
            <div style={{width:'100%', paddingRight:5,}}>
                <div>
                    <label htmlFor="email" className="block text-sm/6 font-small text-gray-900">
                        Fecha final
                    </label>
                </div>
                <div className="mt-2">
                    <input
                    id="email"
                    name="email"
                    type="date"
                    placeholder="you@example.com"
                    aria-describedby="email-optional"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                    />
                </div>
            </div>
        )
    }


    renderType = () => {
        return (
        <fieldset style={{width:'100%', paddingRight:5,}}>
            <div>
                <label htmlFor="email" className="block text-sm/6 font-small text-gray-900">
                    Tipo
                </label>
            </div>
          <div className="space-y-2">
            <div className="relative flex items-start">
              <div>
                <select
                  id="location"
                  name="location"
                  defaultValue="Canada"
                  className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm/6"
                >
                  <option>Todos</option>
                  <option>Multas</option>
                  <option>Multas con gruas</option>
                  <option>Advertencias</option>
                </select>
              </div>
            </div>
          </div>
        </fieldset>
      )
    }

    renderCreateUserModal = () => {
        const { showCreateUserModal, createUserForm, createUserErrors } = this.state;
        if (!showCreateUserModal) return null;
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
                <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6 relative">
                    <h2 className="text-xl font-bold mb-4">Crear usuario</h2>
                    <form onSubmit={this.handleCreateUserSubmit}>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Identificación *</label>
                                <input
                                    name="identification"
                                    value={createUserForm.identification}
                                    onChange={this.handleCreateUserChange}
                                    className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${createUserErrors.identification ? 'border-red-500' : ''}`}
                                    type="text"
                                />
                                {createUserErrors.identification && <span className="text-xs text-red-500">{createUserErrors.identification}</span>}
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Primer nombre *</label>
                                <input
                                    name="firstName"
                                    value={createUserForm.firstName}
                                    onChange={this.handleCreateUserChange}
                                    className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${createUserErrors.firstName ? 'border-red-500' : ''}`}
                                    type="text"
                                />
                                {createUserErrors.firstName && <span className="text-xs text-red-500">{createUserErrors.firstName}</span>}
                            </div>
                            {/*<div>
                                <label className="block text-sm font-medium text-gray-700">Segundo nombre</label>
                                <input
                                    name="middleName"
                                    value={createUserForm.middleName}
                                    onChange={this.handleCreateUserChange}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    type="text"
                                />
                            </div>*/}
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Primer apellido *</label>
                                <input
                                    name="firstLastName"
                                    value={createUserForm.firstLastName}
                                    onChange={this.handleCreateUserChange}
                                    className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${createUserErrors.firstLastName ? 'border-red-500' : ''}`}
                                    type="text"
                                />
                                {createUserErrors.firstLastName && <span className="text-xs text-red-500">{createUserErrors.firstLastName}</span>}
                            </div>
                            
                            {/*<div>
                                <label className="block text-sm font-medium text-gray-700">Segundo apellido</label>
                                <input
                                    name="middleLastName"
                                    value={createUserForm.middleLastName}
                                    onChange={this.handleCreateUserChange}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    type="text"
                                />
                            </div>*/}
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Género *</label>
                                <select
                                    name="gender"
                                    value={createUserForm.gender}
                                    onChange={this.handleCreateUserChange}
                                    className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${createUserErrors.gender ? 'border-red-500' : ''}`}
                                >
                                    <option value="">Seleccione</option>
                                    <option value="M">MASCULINO</option>
                                    <option value="F">FEMENINO</option>
                                </select>
                                {createUserErrors.gender && <span className="text-xs text-red-500">{createUserErrors.gender}</span>}
                            </div>
                            <div className="md:col-span-2">
                                <label className="block text-sm font-medium text-gray-700">Teléfonos *</label>
                                {createUserForm.phone.map((p, idx) => (
                                    <div key={idx} className="flex items-center mb-1">
                                        <input
                                            name="phone"
                                            value={p}
                                            onChange={e => this.handleCreateUserChange(e, idx)}
                                            className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${createUserErrors.phone ? 'border-red-500' : ''}`}
                                            type="text"
                                            placeholder="Teléfono"
                                        />
                                        {createUserForm.phone.length > 1 && (
                                            <button type="button" onClick={() => this.removePhoneField(idx)} className="ml-2 text-red-500 hover:text-red-700">✕</button>
                                        )}
                                    </div>
                                ))}
                                <button type="button" onClick={this.addPhoneField} className="mt-1 text-blue-600 hover:underline text-xs">Agregar otro teléfono</button>
                                {createUserErrors.phone && <span className="text-xs text-red-500 block">{createUserErrors.phone}</span>}
                            </div>
                            <div className="md:col-span-2">
                                <label className="block text-sm font-medium text-gray-700">Correo electrónico *</label>
                                <input
                                    name="email"
                                    value={createUserForm.email}
                                    onChange={this.handleCreateUserChange}
                                    className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${createUserErrors.email ? 'border-red-500' : ''}`}
                                    type="email"
                                />
                                {createUserErrors.email && <span className="text-xs text-red-500">{createUserErrors.email}</span>}
                            </div>
                            <div className="md:col-span-2">
                                <label className="block text-sm font-medium text-gray-700">Dirección *</label>
                                <input
                                    name="address"
                                    value={createUserForm.address}
                                    onChange={this.handleCreateUserChange}
                                    className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${createUserErrors.address ? 'border-red-500' : ''}`}
                                    type="text"
                                />
                                {createUserErrors.address && <span className="text-xs text-red-500">{createUserErrors.address}</span>}
                            </div>
                        </div>
                        {
                            this.state.loadingCreateUser ? 
                                <center>
                                    <ClipLoader
                                        color={'gray'}
                                        loading={true}
                                        size={50}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"/>
                                </center>
                                :
                                <div className="mt-6 flex justify-end gap-2">
                                    <button type="button" onClick={this.closeCreateUserModal} className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300">Cancelar</button>
                                    <button type="submit" className="px-4 py-2 bg-blue-950 text-white rounded hover:bg-blue-950">Guardar</button>
                                </div>
                        }
                    </form>
                    <button onClick={this.closeCreateUserModal} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-xl">×</button>
                </div>
            </div>
        );
    }

    renderEditUserModal = () => {
        const { showEditUserModal, editUserForm, loadingEditUser } = this.state;
        if (!showEditUserModal) return null;
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
                <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
                    <h2 className="text-xl font-bold mb-4">Editar usuario</h2>
                    <form onSubmit={this.handleEditUserSubmit}>
                        <div className="space-y-3">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Identificación</label>
                                <input
                                    name="identification"
                                    value={editUserForm.identification}
                                    disabled
                                    className="mt-1 block w-full rounded-md border-gray-300 bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    type="text"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Correo electrónico</label>
                                <input
                                    name="email"
                                    value={editUserForm.email}
                                    onChange={this.handleEditUserChange}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    type="email"
                                    placeholder=""
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Teléfono celular</label>
                                <input
                                    name="phone"
                                    value={editUserForm.phone}
                                    onChange={this.handleEditUserChange}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    type="text"
                                    placeholder=""
                                />
                            </div>
                        </div>
                        {
                            loadingEditUser ? (
                                <center className="mt-6">
                                    <ClipLoader color={'gray'} loading={true} size={40} aria-label="Loading Spinner" data-testid="loader"/>
                                </center>
                            ) : (
                                <div className="mt-6 flex justify-end gap-2">
                                    <button type="button" onClick={this.closeEditUserModal} className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300">Cancelar</button>
                                    <button type="submit" className="px-4 py-2 bg-blue-950 text-white rounded hover:bg-blue-950">Actualizar</button>
                                </div>
                            )
                        }
                    </form>
                    <button onClick={this.closeEditUserModal} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-xl">×</button>
                </div>
            </div>
        );
    }

  render() {
        return (
        <div className="px-4 sm:px-6 lg:px-8">
            {this.renderCreateUserModal()}
            {this.renderEditUserModal()}
            <div style={{marginBottom:10}}>
                    {this.props.withoutNav ? null : <Breadcrumb pages={this.BreadcrumbPages}/>}
                    
                </div>

                <div class="w-full p-4">
                    <div class="w-full rounded overflow-hidden shadow-lg bg-white" style={{backgroundColor:'#f1f4ff'}}>
                        <div class="px-6 py-4 flex justify-between items-center">
                            <p class="text-gray-700 text-base" style={{fontWeight:'bold'}}>
                                En esta sección podrás ver el historial de multas que posee cualquier persona o vehiculo registrado en el sistema.
                            </p>
                            <button
                                type="button"
                                onClick={this.openCreateUserModal}
                                className="rounded-md bg-blue-950 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-950"
                            >
                                Crear usuario
                            </button>
                        </div>
                    </div>
                </div>

                <div className="sm:flex sm:items-center flex justify-between">
                    {
                        this.props.defaultFilter === false ? null : this.searchInput()
                    }
                </div>
            <div className="mt-8 flow-root">
                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-300">
                        <thead className="bg-gray-50">
                        <tr>
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                NOMBRE
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                APELLIDO
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                IDENTIFICACIÓN
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                CANTIDAD DE MULTAS
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                VEHÍCULOS
                            </th>
                            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                <span className="sr-only">Edit</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 bg-white">
                            {
                                this.state.loading ? 
                                    <center>
                                        <ClipLoader
                                            color={'gray'}
                                            loading={true}
                                            size={50}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"/>
                                    </center>
                                    :
                                this.state.items.map((penalitie) => (
                                    <tr key={penalitie.cost} className="even:bg-gray-50">
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{penalitie.firstName}</td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{penalitie.firstLastName}</td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{penalitie.identification}</td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{penalitie.headerFine ? penalitie.headerFine.length : 0}</td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{penalitie.vehicle ? penalitie.vehicle.length : 0}</td>
                                        <td>
                                            <div style={{display:'flex', flexDirection:'row'}}>
                                                    <div style={{paddingLeft:10}}>
                                                        <Link to={penalitie.identification}>
                                                            <button 
                                                                title='Ver detalle'
                                                                type="button"
                                                                className="rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                                                >
                                                                <MagnifyingGlassIcon aria-hidden="true" className="h-5 w-5" />
                                                            </button>
                                                        </Link>
                                                    </div>
                                                    <div style={{paddingLeft:10}}>
                                                        <button
                                                            title='Editar'
                                                            type="button"
                                                            onClick={() => this.openEditUserModal(penalitie)}
                                                            className="rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                                        >
                                                            <PencilSquareIcon aria-hidden="true" className="h-5 w-5" />
                                                        </button>
                                                    </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                    </div>
                </div>
                </div>
            </div>


            {/* The toast */}
            <ToastContainer position="top-center" hideProgressBar={true}/>
        </div>
        
        )
    }
}

export default UsersPenalities;